module.exports = __webpack_public_path__ + "static/media/William-Trevillyan.1a23ef90.jpg";